import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { AppBar, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { closeSchedulerModal } from 'Context/NewClientSchedulerContext';
import { noop } from 'Helpers/PropTypes';

const styles = theme => ({
  root: {
    display: 'flex',
    height: 54,
    padding: 0,
    backgroundColor: theme.palette.facet.backgroundGray,
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
  },
  closeIcon: {
    color: theme.palette.facet.primaryGray,
    fontSize: 18,
  },
  titleText: {
    color: theme.palette.facet.accentBlue19,
    fontSize: 14,
    margin: 'auto',
  },
});

const SchedulerModalHeader = ({
  className,
  classes,
  onClose,
}) => {
  return (
    <AppBar className={classNames(className, classes.root)} elevation={0}>
      <IconButton
        className={classes.closeButton}
        onClick={() => {
          onClose();
          closeSchedulerModal();
        }}
      >
        <CloseIcon className={classes.closeIcon} />
      </IconButton>
      <div className={classes.titleText}>
        {'SCHEDULE MEETING'}
      </div>
    </AppBar>
  );
};

SchedulerModalHeader.defaultProps = {
  className: '',
  onClose: noop,
};

SchedulerModalHeader.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func,
};

export default withStyles(styles)(SchedulerModalHeader);
